import { Diagnostic, DiagnosticSeverity } from 'vscode-languageserver-protocol';

/** Aligns with Monaco markers and the Problems drawer: undefined severity is treated as an error. */
export function isBlockingDiagnosticSeverity(severity: DiagnosticSeverity | undefined): boolean {
  return severity === undefined || severity === DiagnosticSeverity.Error;
}

export function getBlockingDiagnostics(diagnostics: Diagnostic[]): Diagnostic[] {
  return diagnostics.filter((diagnostic) => isBlockingDiagnosticSeverity(diagnostic.severity));
}

export function hasBlockingLinterErrors(diagnostics: Diagnostic[]): boolean {
  return getBlockingDiagnostics(diagnostics).length > 0;
}

export function areLinterDiagnosticsCurrentForLoadedProject(
  loadedProjectId: string | null | undefined,
  diagnosticsProjectId: string | null,
  programCode: string | undefined,
  diagnosticsProgramCode: string | null
): boolean {
  if (!programCode) return true;
  if (!loadedProjectId) return false;
  return loadedProjectId === diagnosticsProjectId && programCode === diagnosticsProgramCode;
}
